import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, Home, Building2, Key, Truck, Map, ArrowRight, CheckCircle } from 'lucide-react';
import { services } from '../data/mock';

const Services = () => {
  const iconMap = {
    'Vente de Terrains': MapPin,
    'Vente de Biens Immobiliers': Home,
    'Construction Clé en Main': Building2,
    'Gérance Immobilière': Key,
    'Terrassement': Truck,
    'Lotissement': Map
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.8)), url('https://images.unsplash.com/photo-1627141234469-24711efb373c')`
          }}
        />
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Nos Services</h1>
          <p className="text-xl max-w-2xl mx-auto text-slate-200">
            Une gamme complète de services immobiliers pour répondre à tous vos besoins
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="space-y-16">
            {services.map((service, index) => {
              const Icon = iconMap[service.nomService] || Home;
              const isEven = index % 2 === 0;
              
              return (
                <div key={service.idService} className="max-w-6xl mx-auto">
                  <Card className="overflow-hidden border-0 shadow-xl">
                    <div className={`grid md:grid-cols-2 gap-0 ${
                      isEven ? '' : 'md:grid-flow-dense'
                    }`}>
                      {/* Image */}
                      <div className={`relative h-80 md:h-auto ${
                        isEven ? '' : 'md:col-start-2'
                      }`}>
                        <div className="absolute inset-0 bg-gradient-to-br from-amber-600 to-amber-800 opacity-90" />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <Icon className="w-32 h-32 text-white opacity-50" />
                        </div>
                      </div>

                      {/* Content */}
                      <CardContent className="p-8 md:p-12 flex flex-col justify-center">
                        <div className="w-16 h-16 rounded-xl bg-amber-100 flex items-center justify-center mb-6">
                          <Icon className="w-8 h-8 text-amber-600" />
                        </div>
                        <h2 className="text-3xl font-bold text-slate-900 mb-4">{service.nomService}</h2>
                        <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                          {service.description}
                        </p>
                        
                        {/* Features */}
                        <div className="space-y-3 mb-8">
                          {service.caracteristiques.map((feature, idx) => (
                            <div key={idx} className="flex items-center gap-3">
                              <CheckCircle className="w-5 h-5 text-amber-600 flex-shrink-0" />
                              <span className="text-slate-700">{feature}</span>
                            </div>
                          ))}
                        </div>

                        <Button asChild className="bg-amber-600 hover:bg-amber-700 w-full md:w-auto">
                          <Link to="/contact">
                            Contacter PAM IMMO SERVICES
                            <ArrowRight className="ml-2 w-4 h-4" />
                          </Link>
                        </Button>
                      </CardContent>
                    </div>
                  </Card>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Besoin d'un service personnalisé ?
          </h2>
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Nos experts sont à votre disposition pour étudier votre projet et vous proposer 
            des solutions adaptées à vos besoins spécifiques.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-amber-600 hover:bg-amber-700 text-lg px-8">
              <Link to="/contact">Demander un devis gratuit</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="bg-white/10 border-white text-white hover:bg-white hover:text-slate-900 text-lg px-8">
              <Link to="/properties">Découvrir nos biens</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;